import moment from 'moment-timezone';
import hateoas from 'viralstyle-ui/src/hateoas';
import storage from 'viralstyle-ui/src/storage';
import requestService from 'viralstyle-ui/src/requestService';

class PromotionsApi {
  getPromotions(collection) {
    let filterCount = 0,
      url = `${hateoas.url('client_promotions_search')}?page={page}&limit={limit}`;

    url = url.assignParams({ clientId: storage.get('client-hash'), page: collection.page, limit: collection.limit });

    if (collection.query) {
      url += `&filters[${filterCount}]=relates_to:${encodeURIComponent(collection.query)}`;
      filterCount++;
    }

    url += `&sort=${collection.sortColumn}:${collection.sortDirection === 0 ? 'DESC' : 'ASC'}`

    if (collection.campaignId) {
      url += `&filters[${filterCount}]=campaign_id:${collection.campaignId}`;
      filterCount++;
    }

    return requestService.get(url)
  }

  getPromotion(promotionId) {
    return requestService.get(hateoas.url('promotion_details', { clientId: storage.get('client-hash'), promotionId }));
  }

  toggleActivated(promotion, activated) {
    return requestService.put(`${promotion._links.self.href}/${activated ? 'activate' : 'deactivate'}`);
  }

  saveOrUpdatePromotion(promotion) {
    let payload = {
      code: promotion.code,
      description: promotion.description,
      expiration_date: moment(promotion.expiration_date).format('MM/DD/YYYY'),
      amount: parseFloat(promotion.discount),
      type: promotion.discount_type,
      restriction_id: promotion.restriction_id,
      restriction_type: promotion.restriction_type,
      active: promotion.activated
    };

    if (promotion.id) {
      return requestService.put(hateoas.url('update_promotion', { clientId: storage.get('client-hash'), promotionId: promotion.id }), payload);
    } else {
      return requestService.post(hateoas.url('create_promotion', { clientId: storage.get('client-hash') }), payload);
    }
  }

  removePromotion(promotion) {
    return requestService.delete(hateoas.url('delete_promotion', { clientId: storage.get('client-hash'), promotionId: promotion.id }));
  }

  getPromotableCampaigns() {
    return requestService.get(hateoas.url('promotable_client_campaigns', { clientId: storage.get('client-hash') }));
  }
};

export default new PromotionsApi();